import React, {memo} from 'react';
import theme from './style';
import PropTypes from 'prop-types';
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip
} from '@material-ui/core';
import {useParams, useHistory} from "react-router-dom";
import WarningIcon from '@material-ui/icons/Warning';
import moment from 'moment';
import translate from '../../../misc/applyTranslation';
import toValue from '../../../misc/serializeToValue'
import {useConfig} from "../../../context/configContext";

const LatestBatchedInvoices = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const params = useParams();
  const history = useHistory();
  const {
    title,
    data,
  } = props;

  function formatNumberWithSpaces(number) {
    // Convert number to string
    let numStr = String(number);

    // Split the string into integer and decimal parts
    let [integerPart, decimalPart] = numStr.split(',');

    // Insert spaces every third non-decimal character in the integer part
    let formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    // Combine integer and decimal parts with a comma
    let formattedNumber = formattedIntegerPart + (decimalPart ? ',' + decimalPart : '');

    return formattedNumber;
  }

  const handleNumberClick = batch_id => {
    history.push(`/${params.lang}/invoices/details/${batch_id}`);
  }

  return (
    <TableContainer component={Paper} className={classes.container}>
      <div className='title'>{title}</div>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>{translate('invoices', 'batch_latest_table_name')}</TableCell>
            <TableCell>{translate('invoices', 'batch_latest_table_in_day')}</TableCell>
            <TableCell>{translate('invoices', 'batch_latest_table_due_day')}</TableCell>
            <TableCell>{translate('invoices', 'batch_latest_table_created_day')}</TableCell>
            <TableCell>{translate('invoices', 'batch_latest_table_filter')}</TableCell>
            <TableCell>{translate('invoices', 'batch_latest_table_only_fees')}</TableCell>
            <TableCell>{translate('invoices', 'batch_latest_table_number')}</TableCell>
            <TableCell>{translate('invoices', 'batch_latest_table_sum')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.batch_id} className={!row.downloaded ? classes.bold : ''}>
              <TableCell>{row.name}</TableCell>
              <TableCell>{moment.unix(row.inv_day).format('YYYY-MM-DD')}</TableCell>
              <TableCell>{moment.unix(row.due_day).format('YYYY-MM-DD')}</TableCell>
              <TableCell>{moment.unix(row.create_date).format('YYYY-MM-DD')}</TableCell>
              <TableCell>
                {row.filter ?
                  <Tooltip title={row.filter}>
                    <p>{translate('invoices', 'batch_latest_table_see_all')}</p>
                  </Tooltip>
                  :
                  <></>
                }
              </TableCell>
              <TableCell>{row.only_fees}</TableCell>
              <TableCell className={classes.number_invoices_cell} onClick={() => handleNumberClick(row.batch_id)}>
                <div className={classes.number_invoices_wrap}>
                  {`${row.number_invoices_imported_to_ropo} / ${row.number_invoices}`}
                  {Number(row.number_invoices_imported_to_ropo) < Number(row.number_invoices) &&
                    <WarningIcon className={classes.warning_icon}/>}
                </div>
              </TableCell>
              <TableCell>{formatNumberWithSpaces(toValue(row.sum)) + " kr"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
LatestBatchedInvoices.propTypes = {
  data: PropTypes.array.isRequired
}

export default memo(LatestBatchedInvoices);
